export default function getRouteFromState(state) {
	return state?.routes[state?.index || 0];
}
